export const applicationNotesKey = 'applicationNotes';
export const errorMessage = 'Sorry, something went wrong';
